export const address_slice = (addr: string):string =>{
    if (addr.length <7 ) return addr;
    return `${addr.slice(0, 6)}...${addr.slice(-4)}`
}